import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { MAINTENANCE_PLANNING_PATH } from '../../../../config/paths';
import { MAINTENANCE_PLANNING_STATUS_CREATED } from '../../../../config/constants';
import EndMaintenancePlanningButton from './EndMaintenancePlanningButton';
import AddResourceMaintenancePlanningButton from './AddResourceMaintenancePlanningButton';

const MaintenancePlanningToolbar = ({
  maintenancePlanningId,
  status,
  maintenancePlanning,
}) => (
  <ButtonToolbar className="pull-right">
    <div>
      {status === MAINTENANCE_PLANNING_STATUS_CREATED && (
        <EditButton
          path={`${MAINTENANCE_PLANNING_PATH}/${maintenancePlanningId}/edit`}
        />
      )}{' '}
      <AddResourceMaintenancePlanningButton
        maintenancePlanning={maintenancePlanning}
      />{' '}
      {status !== MAINTENANCE_PLANNING_STATUS_CREATED && (
        <>
          <EndMaintenancePlanningButton
            maintenancePlanning={maintenancePlanning}
          />
        </>
      )}
    </div>
  </ButtonToolbar>
);

MaintenancePlanningToolbar.propTypes = {
  maintenancePlanningId: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  maintenancePlanning: PropTypes.instanceOf(Object).isRequired,
};

export default MaintenancePlanningToolbar;
